import { createSignal } from "solid-js";
import { useNavigate } from "@solidjs/router";
import { generateInterview } from "../../services/GPTService.js";
import {
  userEmail,
  setInterview,
  userInterviews,
  setUserInterviews,
} from "../../stores/userStore.js";
import { getAzureToken } from "../../services/interviewActions/interviewService.js";
import Loading from "../Loading.jsx";

export default function DescriptionForm() {
  const [description, setDescription] = createSignal("");
  const [generationErrror, setGenerationError] = createSignal(0);
  const [loading, setLoading] = createSignal(false);
  const [hovering, setHovering] = createSignal(false);
  const nav = useNavigate();

  const handleSubmit = async (e) => {
    setGenerationError(0);
    console.log(description());
    e.preventDefault();
    setLoading(true);
    // Generate interview and save to DB
    const interview = await generateInterview(userEmail(), description());

    if (!interview) {
      setGenerationError(1);
      return;
    }
    setInterview(interview);
    // console.log(`Set interview to ${interview}`);
    await getAzureToken();
    setLoading(false);
    nav(`/interview/${interview._id}`);
    setUserInterviews([...(userInterviews() || []), interview]);
  };

  return (
    <div style="padding: 0;">
      <form onSubmit={handleSubmit}>
        <textarea
          class="description-text-area"
          placeholder="Paste a job description"
          onInput={(d) => setDescription(d.currentTarget.value)}></textarea>
        <Show when={generationErrror() === 1}>
          <p class="subtext" style="padding: 0; margin-bottom: 3px;">
            Could not generate an interview. Try pasting a more detailed job
            description.
          </p>
        </Show>
        <button class="button2" type="submit">
          Generate Interview
        </button>
      </form>
      <Loading show={loading()} />
    </div>
  );
}
